<template>
  <div
    v-click-outside="close"
    :class="['dropdown', { 'is-active': activate || isActive }]"
  >
    <div class="dropdown-trigger" @click="disableToggle ? {} : toggle()">
      <slot />
    </div>
    <div ref="dropdownMenu" class="dropdown-menu">
      <div class="dropdown-content">
        <slot name="content" :close="close" />
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from '@sephora-asia/click-outside'
export default {
  name: 'Dropdown',
  directives: {
    ClickOutside
  },
  props: {
    /** reference name that this dropdown is bounded by */
    boundary: {
      type: String,
      default: ''
    },
    activate: {
      type: Boolean,
      default: false
    },
    disableToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    // Close dropdowns if ESC pressed
    document.addEventListener('keydown', (event) => {
      if (event.keyCode === 27) {
        this.close()
      }
    })

    if (this.boundary) {
      this.reposition()
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
      if (this.isActive === false) {
        this.$emit('close')
      }
    },
    close() {
      this.isActive = false
      this.$emit('close')
    },
    // This method will traverse from the dropdown's parent, to the parent's parent and so forth
    // It will stop only when it finds the bounding Element or when it reaches the root node (document)
    getBoundingElement(node) {
      const boundingElement = node.$refs[this.boundary]
      if (boundingElement) {
        return boundingElement
      } else if (node.$parent) {
        return this.getBoundingElement(node.$parent)
      } else {
        console.error('[Error] Ref not found: ', this.boundary)
      }
    },
    reposition() {
      // BoundingElement is the parent of this dropdown.
      // Visually, it is the box that will contain the dropdown trigger and its content
      const boundingElement = this.getBoundingElement(this.$parent)
      if (boundingElement) {
        // This is the content that we don't to go beyond the boundElement's right side. I
        // It is still possible the content will overflow on the left side when the content is wider than
        // boundingElement
        const content = this.$refs.dropdownMenu
        // This is the boundingElement `right` attribute
        const boundaryRight = boundingElement.getBoundingClientRect().right
        // This is the content `right` attribute
        const contentRight = content.getBoundingClientRect().right
        // This is length wherein the content overflows beyond the boundingElement
        // Negative value means that it has overflowed
        const overflowWidth = boundaryRight - contentRight

        if (overflowWidth < 0) {
          // Content `left` attribute is 0 by default
          // Adding a negative value will move it further to the left side. Therefore, setting
          // the overflowWidth as the value will offset the overflow to the left side instead
          // of the right side
          // After setting the `left` attribute to the overflowWidth, the difference between
          // boundaryRight and contentRight will be 0.
          content.style.left = `${overflowWidth}px`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/dropdown';
.dropdown-item {
  font-size: 13px;
}
.dropdown-title {
  font-weight: 700;
}
// Toggling visiblity instead of removing from DOM because it is required for
// the content's offsetWidth and scrollWidth calculation to fix the flexbox issue for navigation menu
// https://stackoverflow.com/questions/33891709/when-flexbox-items-wrap-in-column-mode-container-does-not-grow-its-width
.dropdown-menu {
  display: block;
  visibility: hidden;
}
.dropdown.is-active,
.dropdown.is-hoverable:hover {
  .dropdown-menu {
    visibility: visible;
  }
}
.dropdown.is-full-width {
  display: flex;
  .dropdown-trigger,
  .dropdown-menu {
    width: 100%;
  }
}
</style>
